import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import BurgerMenu from '@shared/burger-menu';
import IconNavigation from '@shared/icon-navigation';
import SideMenu from '@shared/side-menu';
import AccountNavigation from '@molecule/account-navigation';
import Template from '@scaffolding/template';
import HamburgerNavigation from '@molecule/hamburger-navigation';
import connect from '@clearscore/redux.connect';
import { selectors as profileSelectors } from '@clearscore/redux.profile';
import { NavLink } from 'react-router-dom';
import Media from 'react-media';
import Logo from '@clearscore/icons.clearscore-logo-with-text-rainbow';
import breakpoints from '@bond/breakpoints';

import styles from './header.css';

const Header = ({ hasBurgerMenu, routerTrackingSource, hasDefectedReport }) => {
    const { firstName } = useSelector(profileSelectors.getSimple);
    const [isBurgerMenuOpen, toggleBurgerMenu] = useState(false);
    const [isAccountMenuOpen, toggleAccountMenu] = useState(false);

    return (
        <header role="navigation" id="webapp-core-header">
            {/* id="webapp-core-header" is required for dynamic dashboard */}
            <Template>
                <div className={styles.header}>
                    <HamburgerNavigation
                        hasBurgerMenu={hasBurgerMenu}
                        handleToggle={() => toggleBurgerMenu(!isBurgerMenuOpen)}
                    />
                    <Media query={breakpoints.l}>
                        {(mediaMatches) => (
                            <Choose>
                                <When condition={mediaMatches && !hasDefectedReport}>
                                    <IconNavigation
                                        className={styles.headerCenter}
                                        menu="primary"
                                        routerTrackingSource={routerTrackingSource}
                                    />
                                </When>

                                <Otherwise>
                                    <NavLink to="/" className={styles.headerCenterLogo} data-qa="head-center-logo">
                                        <div className={styles.logoWrapper}>
                                            <Logo />
                                        </div>
                                    </NavLink>
                                </Otherwise>
                            </Choose>
                        )}
                    </Media>
                    <AccountNavigation
                        firstName={firstName}
                        hasBurgerMenu={hasBurgerMenu}
                        routerTrackingSource={routerTrackingSource}
                        handleAccountToggle={() => toggleAccountMenu(!isAccountMenuOpen)}
                    />

                    <If condition={hasBurgerMenu}>
                        <BurgerMenu
                            initialIsOpen={isBurgerMenuOpen}
                            onClose={() => toggleBurgerMenu(!isBurgerMenuOpen)}
                            routerTrackingSource={routerTrackingSource}
                            drawerDataId="header-burger-menu"
                        />
                    </If>

                    <SideMenu
                        drawerDataId="header-side-menu"
                        isOpen={isAccountMenuOpen}
                        closeDrawer={() => toggleAccountMenu(!isAccountMenuOpen)}
                    />
                </div>
            </Template>
        </header>
    );
};

Header.propTypes = {
    hasBurgerMenu: PropTypes.bool,
    routerTrackingSource: PropTypes.string,
    hasDefectedReport: PropTypes.bool,
};

Header.defaultProps = {
    hasBurgerMenu: true,
    routerTrackingSource: '',
    hasDefectedReport: false,
};

export default connect(null, null, { useRouter: true })(Header);
